import React, { Component } from 'react'

import {connect} from "react-redux";
import Card from "@material-ui/core/Card/Card";
import Typography from '@material-ui/core/Typography';

import Amplify, { PubSub } from 'aws-amplify';
import { AWSIoTProvider } from '@aws-amplify/pubsub/lib/Providers';
import Grid from "@material-ui/core/Grid/Grid";
import TireBrandsParetoChart from "../../Producao/TiresDashboard/TireBrandsParetoChart";
import withStyles from "@material-ui/core/styles/withStyles";
import arcoRaspaImg from '../../../assets/images/arcoRaspa.png';

//Posicoes da Raspa
import r01 from '../../../assets/images/raspa/r01.png';

import r02 from '../../../assets/images/raspa/r02.png';
import r03 from '../../../assets/images/raspa/r03.png';
import r04 from '../../../assets/images/raspa/r04.png';

import r05 from '../../../assets/images/raspa/r05.png';
import r06 from '../../../assets/images/raspa/r06.png';

import r07 from '../../../assets/images/raspa/r07.png';
import r08 from '../../../assets/images/raspa/r08.png';
import Paper from "@material-ui/core/Paper/Paper";
import Button from "@material-ui/core/Button/Button";
import {getRaspas} from "../../../actions/raspaCycleActions";
import {checkNull} from "../../../utils/utils";


const NA = 'N/A'


const styles = theme => ({
    dashboardSection: {
        // marginTop: "50px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    chartGrid: {
        textAlign: 'center',
        padding: "10px",
        //  marginBottom: "20px"
    },

    rootEstadoMandril: {
        display: 'flex'
    },
    gridContainerEstadoMandril: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: theme.spacing(3),
    },
    gridEstadoMandril:{
      borderWidth: '1px',
      padding: '5px'

    },
    paperEstadoMandril: {
       // padding: theme.spacing(1),
        textAlign: 'center',
        color: 'white', //theme.palette.text.secondary,
        backgroundColor: 'transparent',
        borderColor: 'green',
        borderWidth: '2px',
        borderStyle: 'solid',
        whiteSpace: 'nowrap',
        marginBottom: theme.spacing(1),
        borderRadius: 2
    },
    imgRaspa: {
      width: '100%',
      height: '100%'
    },

    gridReceitaRaspa: {
     //   backgroundImage: `url(${arcoRaspaImg})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    },

    selecionado: {
        fontStyle: 'Bold'
    }
})


Amplify.configure({
    Auth: {
        identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID || 'us-east-1:88f3c2d5-c532-458c-9914-a3795a5298cb',
        region: process.env.REACT_APP_REGION  || 'us-east-1',
        userPoolId: process.env.REACT_APP_USER_POOL_ID || 'us-east-1_i0Z5DuhGh',
        userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID || '2rln0vtqd0bfo20drnl2kjnc4i'
    }
});
Amplify.addPluggable(new AWSIoTProvider({
    aws_pubsub_region: process.env.REACT_APP_REGION || 'sa-east-1',
    aws_pubsub_endpoint: 'wss://a36lbw95mpi0hj-ats.iot.sa-east-1.amazonaws.com/mqtt' //`wss://${process.env.REACT_APP_MQTT_ID}.iot.${process.env.REACT_APP_REGION}.amazonaws.com/mqtt`,
}));



let iotAWSQueue;




class RaspaMonitor extends Component {



    constructor(props) {
        super(props)
        this.state = {
            mqttHabilitado: false,

            m1_inflado: false,
            m1_raspando: false,

            m2_inflado: false,
            m2_raspando: false,

            m1: {
                AvancoManual: 1,
                DataHora: new Date(),
                EstadoMaquina: "Informações não recebidas.",
                ModoRaspagem: "",
                NumeroMandril: 1,
                OrdemServico: "N/D",
                PerimetroAtual: 0,
                PerimetroAvanco: 0,
                PressaoPneu: 0,
                RecAnguloOmbro: 0,
                RecLarguraBanda: 0,
                RecPerimetroFinal: 0,
                RecRaioOmbro: 0,
                RecLarguraOmbro: 0,
                RecRaioPrincipal: 0,
                Receita: "N/D",
                SensorMalha: 0
            },

            m2: {
                AvancoManual: 0,
                DataHora: new Date(),
                EstadoMaquina: "Informações não recebidas.",
                ModoRaspagem: "",
                NeedToSend: "",
                NumeroMandril: 1,
                OrdemServico: "N/D",
                PerimetroAtual: 0,
                PerimetroAvanco: 0,
                PressaoPneu: 0,
                RecAnguloOmbro: 0,
                RecLarguraOmbro: 0,
                RecLarguraBanda: 0,
                RecPerimetroFinal: 0,
                RecRaioOmbro: 0,
                RecRaioPrincipal: 0,
                Receita: "N/D",
                SensorMalha: 0
            }
        }
        this.renderRaspaPosicaoImagem = this.renderRaspaPosicaoImagem.bind(this);
        this.getMqttMessageReceived = this.getMqttMessageReceived.bind(this);
        this.renderMandrilTabela = this.renderMandrilTabela.bind(this);
        this.habilitarMqtt = this.habilitarMqtt.bind(this);
        this.renderContent = this.renderContent.bind(this);
    }

    getMqttMessageReceived(data) {
        console.log(data);
        const d = data.value;

       // if (d.deviceID *1 != 548) { return null }

        const mm = {
            AvancoManual: checkNull(d.AvancoManual,0)   *1,
            DataHora: checkNull(d.DataHora,NA) ,
            EstadoMaquina: checkNull(d.EstadoMaquina,NA) ,
            ModoRaspagem: checkNull(d.ModoRaspagem,NA) ,
            NumeroMandril: checkNull(d.NumeroMandril,NA),
            OrdemServico: checkNull(d.OrdemServico,NA) ,
            PerimetroAtual: checkNull(d.PerimetroAtual,0) *1,
            PerimetroAvanco: checkNull(d.PerimetroAvanco,0) *1,
            PressaoPneu: checkNull(d.PressaoPneu,0) *1,
            RecAnguloOmbro: checkNull(d.RecAnguloOmbro,0) * 1,
            RecLarguraBanda: checkNull(d.RecLarguraBanda,0) *1,
            RecPerimetroFinal: checkNull(d.RecPerimetroFinal,0) *1,
            RecLarguraOmbro: checkNull(d.RecLarguraOmbro,0) * 1,
            RecRaioOmbro: checkNull(d.RecRaioOmbro,0) *1,
            RecRaioPrincipal: checkNull(d.RecRaioPrincipal,0) *1,
            Receita: checkNull(d.Receita,NA) ,
            SensorMalha: checkNull(d.SensorMalha,NA)
        }

        let inflado = false;
        let raspando = false;

        if (checkNull(d.EstadoMaquina,NA).includes("Inflando")) { inflado = true;  raspando = false;}
        if (checkNull(d.EstadoMaquina,NA).includes("Aguardando acab")) { inflado = true;  raspando = true;}
        if (checkNull(d.EstadoMaquina,NA).includes("Aguardando rob")) { inflado = true;  raspando = false;}
        if (checkNull(d.EstadoMaquina,NA).includes("Raspagem")) { inflado = true;  raspando = true;}
        if (checkNull(d.EstadoMaquina,NA).includes("Desinflando")) { inflado = false;  raspando = false;}
        if (checkNull(d.EstadoMaquina,NA).includes("Aguardando bot")) { inflado = false;  raspando = false;}
        if (checkNull(d.EstadoMaquina,NA).includes("Condi")) { inflado = false;  raspando = false;}


       // console.log('Mandril', d.NumeroMandril * 1, inflado, raspando, mm )
        switch( d.NumeroMandril * 1 )
        {
            case 1:
                this.setState({ m1: mm, m1_inflado: inflado, m1_raspando: raspando })
                break;
            case 2:
                this.setState({ m2: mm, m2_inflado: inflado, m2_raspando: raspando})
                break;
            default:
                break;
        }

    }


    // iotAWSQueue = Amplify.PubSub.subscribe(['raspaRobo/traps/548']).subscribe({
    //     next: data => this.getMqttMessageReceived(data),
    //     error: error => console.error("MQTT ERROR", error),
    //     close: () => console.log('MQTT ENDING...'),
    // });

    componentDidMount(){
        this.props.getRaspas();
    }

    componentDidUpdate(){
    }

    componentWillUnmount(){
        console.log('unsubscribe');
        if(iotAWSQueue) { iotAWSQueue.unsubscribe(); }
    }

    renderRaspaPosicaoImagem(){
        const { classes } = this.props;

        if (!this.state.m1_inflado && !this.state.m2_inflado) {
            return <img className={classes.imgRaspa} src={r01} />
        }

        if (this.state.m1_inflado && !this.state.m2_inflado && !this.state.m1_raspando) {
            return <img className={classes.imgRaspa} src={r02} />
        }

        if (!this.state.m1_inflado && this.state.m2_inflado && !this.state.m2_raspando) {
            return <img className={classes.imgRaspa} src={r03} />
        }

        if (this.state.m1_inflado && this.state.m2_inflado && !this.state.m1_raspando && !this.state.m2_raspando) {
            return <img className={classes.imgRaspa} src={r04} />
        }

        if (this.state.m1_inflado && !this.state.m2_inflado && this.state.m1_raspando ) {
            return <img className={classes.imgRaspa} src={r05} />
        }

        if (this.state.m1_inflado && this.state.m2_inflado && this.state.m1_raspando ) {
            return <img className={classes.imgRaspa} src={r06} />
        }

        if (!this.state.m1_inflado && this.state.m2_inflado && this.state.m2_raspando ) {
            return <img className={classes.imgRaspa} src={r07} />
        }
        if (this.state.m1_inflado && this.state.m2_inflado && this.state.m2_raspando ) {
            return <img className={classes.imgRaspa} src={r08} />
        }

        return null;

    }

    renderMandrilTabela(d){
        const { classes } = this.props;

       return <div>
               <Paper>
                    <Grid container  className={classes.rootEstadoMandril} style={{ backgroundColor: '#444444'}} >

                        <Grid item xs={12} sm={12} lg={12} xl={12}>
                            <Grid container>
                                <Grid item xs={6} sm={6} lg={6} xl={6} className={classes.gridEstadoMandril} style={{padding: '5px'}}>
                                    <Paper className={classes.paperEstadoMandril}>
                                    <Typography>Semi - Automático</Typography>
                                    </Paper>
                                </Grid>
                                <Grid item xs={6} sm={6} lg={6} xl={6} className={classes.gridEstadoMandril}>
                                    <Paper className={classes.paperEstadoMandril}>
                                        <Typography>Automático</Typography>
                                    </Paper>
                                </Grid>

                            </Grid>

                        </Grid>

                        {/*numeros*/}
                        <Grid item xs={12} sm={12} lg={12} xl={12} style={{  }}>
                            <Grid container >
                                <Grid item xs={4} sm={4} lg={4} xl={4} className={classes.gridEstadoMandril} style={{ alignItems: 'stretch' }}>
                                    <Grid container style={{ width: '100%', alignItems: 'stretch' }}>
                                        <Grid item style={{ width: '100%', alignItems: 'stretch' }}>
                                            <Paper className={classes.paperEstadoMandril}>
                                                <Typography variant="subtitle1">Distância Malha</Typography>
                                                <Typography variant="h4">{d.SensorMalha}</Typography>
                                            </Paper>
                                        </Grid>
                                        <Grid item style={{ width: '100%', alignItems: 'stretch', marginTop: '10px' }}>
                                            <Paper className={classes.paperEstadoMandril}>
                                                <Typography variant="subtitle1">Pressão do pneu</Typography>
                                                <Typography variant="h4">{d.PressaoPneu}</Typography>
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={8} sm={8} lg={8} xl={8} className={classes.gridEstadoMandril} style={{  padding: '0px'}}>
                                    <Grid container xs={12} sm={12} lg={12} xl={12}  style={{ width: '100%', alignItems: 'stretch' }}>
                                        <Grid item xs={8} sm={8} lg={8} xl={8}  style={{ width: '100%', alignItems: 'stretch' }}>
                                            <Grid container  style={{ width: '100%', alignItems: 'stretch' }}>
                                                <Grid item className={classes.gridEstadoMandril} style={{ width: '100%', alignItems: 'stretch' }}>
                                                    <Paper className={classes.paperEstadoMandril}>
                                                        <Typography variant="subtitle1">Perimetro Atual</Typography>
                                                        <Typography variant="h4">{d.PerimetroAtual}</Typography>

                                                    </Paper>
                                                </Grid>
                                                <Grid item className={classes.gridEstadoMandril} style={{ width: '100%', alignItems: 'stretch' }}>
                                                    <Paper className={classes.paperEstadoMandril}>
                                                        <Typography variant="subtitle1">Perimetro após avanço</Typography>
                                                        <Typography variant="h4">{d.PerimetroAvanco}</Typography>
                                                    </Paper>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={4} sm={4} lg={4} xl={4} style={{ alignItems: 'stretch' }}>
                                            <Grid container  style={{  width: '100%', height: '100%', alignItems: 'stretch' }}>
                                                <Grid item className={classes.gridEstadoMandril} style={{ height: '100%', width: '100%', alignItems: 'stretch' }}>
                                                    <Paper className={classes.paperEstadoMandril} style={{ height: '100%', width: '100%', alignItems: 'stretch' }}>
                                                        <Typography variant="subtitle1">Avanço</Typography>
                                                        <Typography variant="h4">{d.AvancoManual}</Typography>
                                                    </Paper>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>

                        </Grid>

                                    {/*estado maquina*/}
                                    <Grid item xs={12} sm={12} lg={12} xl={12} >
                                        <Paper className={classes.paperEstadoMandril} style={{ borderStyle: 'none' }}>
                                          <Typography variant="h5"> {d.EstadoMaquina}</Typography>
                                        </Paper>
                                    </Grid>

                                    <Grid item xs={12} sm={12} lg={12} xl={12}>
                                        <Paper className={classes.paperEstadoMandril}>
                                            <Typography variant="subtitle1">Receita</Typography>
                                            <Typography variant="h6"> {d.Receita}</Typography>
                                            <Typography variant="subtitle1">Ordem de Serviço</Typography>
                                            <Typography variant="h6"> {d.OrdemServico}</Typography>
                                        </Paper>
                                    </Grid>

                                    <Grid item xs={12} sm={12} lg={12} xl={12} className={classes.gridReceitaRaspa}>
                                        <Paper className={classes.paperEstadoMandril}>
                                            <Grid container>
                                                <Grid item xs={3} sm={3} lg={3} xl={3} >
                                                </Grid>
                                                <Grid item xs={3} sm={3} lg={3} xl={3} >
                                                    <Paper className={classes.paperEstadoMandril} style={{borderStyle:'none'}}>
                                                        <Typography variant="subtitle1">Largura</Typography>
                                                        <Typography variant="h6"> {d.RecLarguraBanda}</Typography>
                                                    </Paper>
                                                    <Paper className={classes.paperEstadoMandril}>
                                                        <Typography variant="subtitle1">Raio</Typography>
                                                        <Typography variant="h6"> {d.RecRaioPrincipal}</Typography>
                                                    </Paper>
                                                    <Paper className={classes.paperEstadoMandril}>
                                                        <Typography variant="subtitle1">Perimetro</Typography>
                                                        <Typography variant="h6"> {d.RecPerimetroFinal}</Typography>
                                                    </Paper>
                                                </Grid>
                                                <Grid item xs={3} sm={3} lg={3} xl={3}>
                                                    <Paper className={classes.paperEstadoMandril}>
                                                        <Typography variant="subtitle1">Angulo Ombro</Typography>
                                                        <Typography variant="h6"> {d.RecAnguloOmbro}</Typography>
                                                    </Paper>
                                                </Grid>
                                                <Grid item xs={3} sm={3} lg={3} xl={3}>
                                                    <Paper className={classes.paperEstadoMandril}>
                                                        <Typography variant="subtitle1">Raio Ombro</Typography>
                                                        <Typography variant="h6"> {d.RecRaioOmbro}</Typography>
                                                    </Paper>
                                                     <Paper className={classes.paperEstadoMandril}>
                                                        <Typography variant="subtitle1">Comprimento Ombro</Typography>
                                                        <Typography variant="h6"> {d.RecLarguraOmbro}</Typography>
                                                    </Paper>
                                                </Grid>

                                            </Grid>
                                        </Paper>
                                    </Grid>
                    </Grid>
               </Paper>
            </div>


    }

    habilitarMqtt(){
        if (!this.state.mqttHabilitado) {

            var q = []
            if (this.props.raspas.length > 0) {

                this.props.raspas.map(r => {
                    console.log("adicionando raspa a fila", r.id.toString())
                    q.push("raspaRobo/traps/" + r.id.toString());
                })

                iotAWSQueue = Amplify.PubSub.subscribe(q).subscribe({
                    next: data => this.getMqttMessageReceived(data),
                    error: error => console.error("MQTT ERROR", error),
                    close: () => console.log('MQTT ENDING...'),
                });
                this.setState({
                    mqttHabilitado: true

                })
            }
        } else {
            if (iotAWSQueue) { iotAWSQueue.unsubscribe(); }
            this.setState({
                mqttHabilitado: false
            })
        }


    }

    renderContent(){
        const { classes } = this.props;
        if (!this.state.mqttHabilitado) {return null}

       return <React.Fragment>
            <Grid item xs={12} lg={12} className={classes.chartGrid}>
                <Grid container>
                    <Grid item xs={6} lg={6} className={classes.chartGrid}>
                        {this.renderMandrilTabela(this.state.m1)}
                    </Grid>

                    <Grid item xs={6} lg={6} className={classes.chartGrid}>
                        {this.renderMandrilTabela(this.state.m2)}
                    </Grid>
                </Grid>

            </Grid>

            <Grid item xs={12} lg={12} className={classes.chartGrid}>
                <Paper>
                    {this.renderRaspaPosicaoImagem()}
                </Paper>

            </Grid>
       </React.Fragment>
    }


    render() {
        const { classes } = this.props;

        // console.log(this.state);

       // console.log("raspas",this.props.raspas);
        return (
            <React.Fragment>

                <Grid container direction="row" >
                    <Grid item  xs={12} lg={12} className={classes.chartGrid}>
                        <Grid item xs={12} lg={12} className={classes.chartGrid}>
                            <Grid container>
                                <Grid item  xs={10} sm={10} lg={10} xl={10}>
                            <Typography variant="h4" align="center" className={classes.sectionTitle}>
                                RASPA - TEMPO REAL
                            </Typography>
                                </Grid>
                                <Grid item  xs={2} sm={2} lg={2} xl={2}>
                                    <Button onClick={this.habilitarMqtt}>{this.state.mqttHabilitado? 'Desativar' : 'Habilitar'}</Button>
                                </Grid>
                            </Grid>
                        </Grid>

                        {this.renderContent()}


                    </Grid>




                </Grid>
            </React.Fragment>



        );
    }
}

const mapStateToProps = (state) => {
    return {
        autoclaves: state.autoclaves,
        raspas: state.raspaCycles.Raspas,
        pneus: state.tires
    }
}

export default connect(mapStateToProps, { getRaspas })(withStyles(styles, {withTheme: true})(RaspaMonitor));
